import React, { useState, useEffect } from 'react';
import { getAllUsers } from '../api/gridApi';

const UserSelector = ({ selectedUserId, onUserChange, currentUser }) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Solo cargamos la lista si el usuario logueado es Admin
    if (currentUser?.menu_admin) {
      const fetchUsers = async () => {
        setLoading(true);
        try {
          const response = await getAllUsers();
          // El backend devuelve un array directo de usuarios
          const userList = Array.isArray(response) ? response : (response.users || response.data || []);
          setUsers(userList);
        } catch (error) {
          console.error("Error cargando usuarios:", error);
        } finally {
          setLoading(false);
        }
      };
      fetchUsers();
    }
  }, [currentUser]);

  if (!currentUser?.menu_admin) return null;

  return (
    <div className="flex items-center space-x-2 bg-blue-50 p-2 rounded-lg border border-blue-100">
      <span className="text-xs font-bold text-blue-800 uppercase tracking-wider">
        Modo Admin:
      </span>
      <select
        value={selectedUserId}
        onChange={(e) => onUserChange(e.target.value)}
        disabled={loading}
        className="bg-white border border-blue-300 text-gray-700 text-sm rounded focus:ring-blue-500 focus:border-blue-500 block p-1.5 min-w-[200px]"
      >
        <option value={currentUser.id}>Mí mismo ({currentUser.nombre})</option>
        {users.map((u) => (
          <option key={u._id} value={u._id}>
            {u.nombre} ({u.email})
          </option>
        ))}
      </select>
    </div>
  );
};

export default UserSelector;